var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilePenSolid2InactiveAssignement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75171 5.66498C1.75171 4.40865 2.77315 3.38721 4.02949 3.38721H9.72393V7.94276C9.72393 8.57271 10.2329 9.08165 10.8628 9.08165H15.4184V13.5553L12.3291 16.6446C11.9626 17.0112 11.7063 17.4667 11.5817 17.9685L10.9162 20.6343C10.8343 20.9617 10.8521 21.3034 10.9625 21.613H4.02949C2.77315 21.613 1.75171 20.5915 1.75171 19.3352V5.66498ZM15.4184 7.94276H10.8628V3.38721L15.4184 7.94276ZM21.3192 11.7758L21.8317 12.2883C22.387 12.8435 22.387 13.744 21.8317 14.3027L20.7854 15.3491L18.2585 12.8222L19.3048 11.7758C19.86 11.2206 20.7605 11.2206 21.3192 11.7758ZM12.8523 18.2284L17.4506 13.6301L19.9775 16.157L15.3792 20.7517C15.2333 20.8976 15.0518 21.0008 14.8489 21.0507L12.71 21.5845C12.5142 21.6343 12.3113 21.5774 12.169 21.435C12.0266 21.2927 11.9697 21.0898 12.0195 20.8941L12.5534 18.7551C12.6032 18.5558 12.7064 18.3707 12.8523 18.2248V18.2284Z",
    fill: "#B2B2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePenSolid2InactiveAssignement);
export default __webpack_public_path__ + "static/media/file-pen-solid 2Inactive-Assignement.8725d8931a43db72fa67588a55c5f1bc.svg";
export { ForwardRef as ReactComponent };